<template>
  <v-dialog :fullscreen="true" v-model="showClosedScreen" transition="fade-transition">
    <v-sheet>
      <v-container :fluid="true" style="height: 100vh" class="pa-0">
        <v-row style="height: 100%" class="ma-0">
          <v-col :cols="isPortrait ? '12' : '8'" id="cover-image" :order="isPortrait ? '0' : '5'" class="pa-0 cover-image">
            <v-img
              :lazy-src="organizationCoverImage('thumbnail')"
              :src="organizationCoverImage('original')"
              :cover="true"
              class="bg-primary cover-image"
            />
          </v-col>
          <v-col :cols="isPortrait ? '12' : '4'" :order="isPortrait ? '5' : '0'" class="d-flex flex-column justify-space-between px-0 py-5">
            <div v-if="(isPortrait && !isKioskMini && $vuetify.display.height < 1200) || !isPortrait" style="height: 4rem" />
            <div class="text-center px-8">
              <div style="font-size: 3em">{{ t('thisKioskIsClosed') }}</div>
              <div v-show="showNextOpeningHour && hasPrinterPaper" style="font-size: 2em">{{ t('opensAgainAt', { date, time }) }}</div>
              <div v-show="!hasPrinterPaper" style="font-size: 2em">{{ t('printerPaperIsOut') }}</div>
            </div>
            <LanguageSelection />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { useI18n } from 'vue-i18n'
import LanguageSelection from '../components/common/LanguageSelection.vue'
import { useStore } from '../stores/store'

export default {
  name: 'ClosedScreen',
  components: {
    LanguageSelection,
  },
  setup() {
    const store = useStore()
    const { t } = useI18n()

    return {
      store,
      t,
    }
  },
  data() {
    return {
      showClosedScreen: false,
      time: null,
      date: null,
    }
  },
  watch: {
    shouldShow(newValue) {
      this.showClosedScreen = newValue
    },
    nextOpeningHour(newValue) {
      if (newValue) {
        this.time = newValue.time
        this.date = newValue.date
      }
    },
  },
  computed: {
    showNextOpeningHour() {
      return Boolean(this.nextOpeningHour)
    },
    systemTimeInMillis() {
      return this.store.systemTimeInMillis
    },
    nextOpeningHour() {
      return this.store.getNextOpeningHour
    },
    hasPrinterPaper() {
      return this.store.hasPrinterPaper
    },
    allowedLanguages() {
      if (typeof this.kiosk === 'undefined' || this.kiosk === null) {
        return []
      }

      if (!Array.isArray(this.kiosk.allowedLanguages)) {
        return [this.defaultLanguage]
      }

      if (!this.kiosk.allowedLanguages.includes(this.defaultLanguage)) {
        return [this.defaultLanguage, ...this.kiosk.allowedLanguages]
      }

      return this.kiosk.allowedLanguages
    },
    isPortrait() {
      return this.$vuetify.display.height >= this.$vuetify.display.width
    },
    isKioskMini() {
      return this.$vuetify.display.mobile
    },
    shouldShow() {
      return this.kiosk && (this.kiosk.active === false || this.kiosk.isOpen === false) && !this.store.checkoutInProgress
    },
    kiosk() {
      return this.store.kiosk
    },
    kioskOpeningHours() {
      if (this.kiosk) {
        return this.kiosk.openingHours
      }
      return null
    },
    organization() {
      if (typeof this.kiosk !== 'undefined' && this.kiosk !== null) {
        return this.kiosk.organization
      }
      return null
    },
  },
  methods: {
    organizationCoverImage(size = 'large') {
      if (typeof this.organization === 'undefined' || this.organization === null) {
        return ''
      }
      return this.store.displayImage(this.organization.cover, size)
    },
  },
}
</script>

<style scoped>
.front-page-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-around;
  background-color: #f8f8f8;
}
@media (orientation: landscape) {
  .cover-image {
    height: 100vh;
  }
}
@media (min-width: 721px) and (orientation: portrait) {
  .cover-image {
    height: 70vh;
  }
}
@media (max-width: 720px) and (orientation: portrait) {
  .cover-image {
    height: 65vh;
  }
}
</style>
